import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedServicesRoutingModule } from './shared-services-routing.module';
import { SharedServicesComponent } from './shared-services.component';
import {ToolbarModule} from 'src/app/layout/toolbar/toolbar.module';
import {IconsModule} from '../../icons/icons.module';
import {SharedModule} from 'src/app/shared/shared.module';
import { TableModule } from 'src/app/table/table.module';
import { LeftSideNavigationModule } from 'src/app/layout/left-side-navigation/left-side-navigation.module';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {SidenavHeaderModule} from 'src/app/components/sidenav-header/sidenav-header.module';
import {MatDividerModule} from '@angular/material/divider';
import {MatTabsModule} from '@angular/material/tabs';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatCardModule} from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import {SearchFilterModule} from 'src/app/components/search-filter/search-filter.module';
import {DropdownFilterModule} from 'src/app/components/dropdown-fliter/dropdown-filter.module';
import {DefaultFilterModule} from '../../components/default-filter/default-filter.module';
import { TenantCostDetailsRoutingModule } from '../cost-mgmt/tenant-cost-details/tenant-cost-details-routing.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SubscriptionTenantModule } from '../subscription-tenant/subscription-tenant.module';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { PageLoaderModule } from 'src/app/components/page-loader/page-loader.module';
import { PipesModule } from 'src/app/pipes/pipes.module';
import {MatMenuModule} from '@angular/material/menu';
import { SharedServiceDetailsComponent } from './shared-service-details/shared-service-details.component';
import { BreadcrumbModule } from 'src/app/components/breadcrumb/breadcrumb.module';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SharedServicesComponent,
    SharedServiceDetailsComponent
  ],
  imports: [
    CommonModule,
    SharedServicesRoutingModule,
    ToolbarModule,
    IconsModule,
    SharedModule,
    TableModule,
    LeftSideNavigationModule,
    MatProgressSpinnerModule,
    SidenavHeaderModule,
    MatDividerModule,
    MatTabsModule,
    MatExpansionModule,
    MatCardModule,
    MatSelectModule,
    DefaultFilterModule,
    MatProgressBarModule,
    SubscriptionTenantModule,
    NgxSkeletonLoaderModule,
    PipesModule,
    PageLoaderModule,
    MatMenuModule,
    BreadcrumbModule,
    FormsModule
  ],
  exports: [
    SharedServicesComponent
  ]
})
export class SharedServicesModule { }

